/**
 * @generated SignedSource<<34ff9952a4e16bef3b896c59b14e88f5>>
 * @relayHash aeb064fd5258286544c0b07f21afde03
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aeb064fd5258286544c0b07f21afde03

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type deBillingDialogContentBillingQuery$variables = {
  id: string;
};
export type deBillingDialogContentBillingQuery$data = {
  readonly appointmentById: {
    readonly " $fragmentSpreads": FragmentRefs<"deBillingDialogContentBillingFragment">;
  } | null;
};
export type deBillingDialogContentBillingQuery = {
  response: deBillingDialogContentBillingQuery$data;
  variables: deBillingDialogContentBillingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deBillingDialogContentBillingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Appointment",
        "kind": "LinkedField",
        "name": "appointmentById",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "deBillingDialogContentBillingFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deBillingDialogContentBillingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Appointment",
        "kind": "LinkedField",
        "name": "appointmentById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "service",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAttribute",
            "kind": "LinkedField",
            "name": "billingAttribute",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isNotBillable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notBillableReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isVisualSymptomExamination",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "aeb064fd5258286544c0b07f21afde03",
    "metadata": {},
    "name": "deBillingDialogContentBillingQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "17bb0a5c9a3ccc1bb5fe70b6e2c32f69";

export default node;
